// Returns the filter data that should be send to the backend
// (Not containing nulls, only sending IDs)
export const simplyfyFilterDataForBackend = filter => {
    const data = {};
    const {
        status,
        filterByClient,
        filterByCourse,
        filterByUsergroup,
        filterByActive,
    } = filter;

    if (filterByClient) {
        data.filterByClientId = filterByClient.id;
    }

    if (filterByCourse) {
        data.filterByCourseId = filterByCourse.id;
    }

    if (filterByUsergroup) {
        data.filterByUsergroupId = filterByUsergroup.id;
    }

    data.status = status;
    data.filterByActive = filterByActive;

    return data;
};
